import ApplyLeaveDialog from '../components/applyLeave/index'
import { useState } from 'react'
import RegularizationForm from '../components/regularization'
import CustomDialogBox from '../components/customDialog'
import PermissionDialog from '../components/permission'
import WorkFromHomeForm from '../components/workFromHome'

const CalendarActions = ({
  selectedDate,
  dialogOpen,
  setDialogOpen,
  onClose,
  isLeaveApproved = false,
  isPermissionApproved = false,
}) => {

    const [leaveDialogOpen,setLeaveDialogOpen] = useState(false);    
    const [regularizationOpen,setRegularizationOpen] = useState(false);
    const [permissionOpen, setPermissionOpen] = useState(false);
    const [wfhOpen, setWfhOpen] = useState(false);

    //Leave Open
    const handleOpenLeave =() => {
        setLeaveDialogOpen(true);
        setDialogOpen(false);
    };

    //Regularize open
    const handleOpenRegularization = () => {
        setRegularizationOpen(true);
        setDialogOpen(false);
    };
    //Regularize Close
    const handleCloseRegularization = () => {
        setRegularizationOpen(false);
        setDialogOpen(false);
    };
    //WFH Open
     const handleOpenWfh = () => {
        setWfhOpen(true);
        setDialogOpen(false);
    };
    //WFH Close
    const handleCloseWfh = () => {
        setWfhOpen(false);
        setDialogOpen(false);
    };
    //Permission Open
    const handleOpenPermission = () => {
        setPermissionOpen(true);
        setDialogOpen(false);
    };
    //Permission Close
    const handleClosePermission = () => {
        setPermissionOpen(false);
        setDialogOpen(false);
    };


  return (
    <>      
        <CustomDialogBox
          open={dialogOpen}
          onClose={onClose}
          handleOpenLeave={handleOpenLeave}
          handleOpenRegularization={handleOpenRegularization}
          handleOpenPermission={handleOpenPermission}
          handleOpenWfh={handleOpenWfh}
          selectedDate={selectedDate}
          isLeaveApproved={isLeaveApproved}
          isPermissionApproved={isPermissionApproved}
        />
        {/* Apply Leave Form  */}
        <ApplyLeaveDialog 
        leaveDialogOpen={leaveDialogOpen}
        setLeaveDialogOpen={setLeaveDialogOpen}
        handleOpenLeave={handleOpenLeave}
        selectedDate={selectedDate}
        /> 
        {/* Regularization Form */}
        <RegularizationForm
        regularizationOpen={regularizationOpen}
        setRegularizationOpen={setRegularizationOpen}
        handleCloseRegularization={handleCloseRegularization}
        selectedDate={selectedDate}
        />
        {/* Work From Home Form */}
        <WorkFromHomeForm
        wfhOpen={wfhOpen}
        setWfhOpen={setWfhOpen}
        handleOpenWfh={handleOpenWfh}
        handleCloseWfh={handleCloseWfh}
        selectedDate={selectedDate}
        />
        {/* Permission Form*/}
        <PermissionDialog
        permissionOpen={permissionOpen}
        setPermissionOpen={setPermissionOpen}
        handleClosePermission={handleClosePermission}
        selectedDate={selectedDate}
        />
         
    </>
)
}

export default CalendarActions